



























































































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { BusyObject } from '@/models/Busy';
import { Brand, GoodOrService, PropertyDelta } from '@/api/braendz';
import { DeltaType, BrandProperties } from '@/models/Delta';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import BrandDetailsTextField from '@/components/Brands/BrandDetailsTextField.vue';
import BrandDetailsAddressField from '@/components/Brands/BrandDetailsAddressField.vue';
import DeltaValueField from '@/components/Fields/DeltaValueField.vue';

@Component({
    components: {
        LoadingView,
        BrandDetailsTextField,
        BrandDetailsAddressField,
        DeltaValueField
    }
})
export default class BrandDetails extends Vue {
    // Expose constants to template
    public readonly BrandProperties = BrandProperties;
    
    // Member
    public defaultCellWidth = 300;

    // Properties
    @Prop({ required: true })
    public brand!: BusyObject<Brand>;

    @Prop({ required: false })
    public deltaType?: DeltaType;

    @Prop({ required: false })
    public propertyDeltas?: PropertyDelta[] | null | undefined;

    // Getter
    public get classifiedGoodsAndServices(): GoodOrService[] | undefined {
        return this.brand.object?.goodsServices?.filter(i => i.niceClass?.key !== undefined)?.sort((a, b) => (a.niceClass?.key ?? '0').localeCompare(b.niceClass?.key ?? '0', undefined, { numeric: true, sensitivity: 'base' }));
    }

    public get unclassifiedGoodsAndServices(): GoodOrService[] | undefined {
        return this.brand.object?.goodsServices?.filter(i => i.niceClass?.key === undefined);
    }

    public get originBrandTypeTitle(): string {
        if(this.brand.object) {
            return this.$util.concat(' - ', this.brand.object.registrationOfficeCode?.shortDescription ?? this.brand.object.registrationOfficeCode?.key, this.$t('brand.details.originBrandType').toString());
        }
        else {
            return this.$t('brand.details.originBrandType').toString();
        }
    }

    // Lifecycle Methods:

    // Methods:
    public toNullableDate(date: string | null | undefined): Date | null {
        return date ? new Date(date) : null;
    }

}
